import messages from 'lang'
import { SideType } from 'scenes/MarketData/types'
import webSocket from 'services/api/webSocket'
import styled from 'styled-components'
import { capitalize } from 'utils/strings'
import { color } from 'utils/styledHelper'

export const Wrapper = styled.div`
  margin: 2rem;
  width: 30rem;
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
`

export const HeaderItem = styled.div<{ side: SideType }>`
  display: flex;
  flex: 1;
  flex-direction: column;

  > :first-child {
    font-weight: 600;
    font-size: 1rem;
    line-height: 150%;
  }

  > :nth-child(2) {
    font-weight: 600;
    font-size: 1.25rem;
    line-height: 150%;
    color: ${(p) => (p.side === 'buy' ? color('green600') : color('red600'))};
    text-transform: capitalize;
  }
`

export const Footer = styled.div`
  display: flex;
  flex-flow: row-reverse;
  flex-direction: row;
  justify-content: space-between;
`

export const getOrderTypeString = (type) =>
  type === webSocket.order.type.STOP_LIMIT ? 'Stop-Limit' : capitalize(type)

export const DetailsWrapper = styled.div`
  margin-top: 1.5rem;
  margin-bottom: 1rem;

  > div {
    display: flex;
    flex-direction: row;
    padding: 6px 1rem;
    border-top: 1px solid ${color('light')};
  }
`

const Base = styled.span`
  flex: 1;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
`

export const Label = styled(Base)`
  color: ${color('body')};
`

export const Value = styled(Base)``

export const TIF_TEXT_MAP = {
  [webSocket.order.tif.IOC]: messages.order_tif_ioc,
  [webSocket.order.tif.FOK]: messages.order_tif_fok,
  [webSocket.order.tif.GTC]: messages.order_tif_gtc,
  [webSocket.order.tif.GTD]: messages.order_tif_gtd
}
